// extracted by mini-css-extract-plugin
export var completionBody = "_hl-2";
export var completionCard = "_hl-0";
export var completionFooter = "_hl-3";
export var completionTitle = "_hl-1";